export default __webpack_public_path__ + "static/media/avatarB5.79859936.png";